import { Link } from 'react-router-dom';
import { contactEmail } from '@/mocks/site';

export default function CtaSection() {
  return (
    <section className="w-full bg-background-50 px-4 pb-16 md:px-8 md:pb-24">
      <div className="relative mx-auto max-w-content overflow-hidden rounded-lg bg-primary-800">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20warm%20abstract%20texture%20of%20layered%20paper%20fibers%20with%20amber%20light%20streaks%2C%20moody%20archival%20backdrop%2C%20deep%20brown%20and%20ochre%20tones%2C%20subtle%20grain%2C%20no%20people&width=1400&height=600&seq=cta-dossier-03&orientation=landscape"
          alt="深色档案纹理背景，用于档案中心投稿与联系版块"
          title="加入档案整理 · 独家黑料档案中心"
          className="absolute inset-0 h-full w-full object-cover opacity-25"
        />
        <div className="relative grid grid-cols-1 gap-8 px-6 py-12 md:grid-cols-[1.3fr_0.7fr] md:items-center md:px-12 md:py-16">
          <div>
            <p className="text-xs font-medium tracking-[0.3em] text-primary-200">参与整理</p>
            <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              你手上的一份旧材料，
              <br className="hidden sm:block" />
              可能正好补上别人缺失的那一块
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
              如果发现条目有误，或愿意提供可公开核对的通讯稿、节目单与行程记录，欢迎来信。
              我们会先核对来源，再决定是否更新条目。
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <a
              href={`mailto:${contactEmail}`}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-3 text-sm font-medium text-primary-900 transition-colors hover:bg-primary-50"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              {contactEmail}
            </a>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              了解整理原则
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}